import { useState, useEffect } from 'react';
import './ContactLinks.scss';

import { FiMail } from 'react-icons/fi';
import { AiFillLinkedin } from 'react-icons/ai';
import { AiFillGithub } from 'react-icons/ai';
import { AiFillPhone } from 'react-icons/ai';
import { useDog } from '../../context/DogContext.jsx';

export default function ContactLinks() {
    const [showContactLinks, setShowContactLinks] = useState(false);
    const { showDog, hideDog } = useDog();

    useEffect(() => {
        setTimeout(() => {
            setShowContactLinks(true);
        }, 7800);
    }, []);

    const iconSize = "2rem";

    return (
        <div className={`contact-links-container ${showContactLinks ? 'show' : ''}`}>
            <a href="mailto:jordiamir@gmail.com" target="_blank" className="contact-link">
                <FiMail size={iconSize} title="Email" className="contact-link-icon" />
            </a>
            <a href="https://www.linkedin.com/in/yarden-amir-96348898/" target="_blank" className="contact-link">
                <AiFillLinkedin size={iconSize} title="Linkedin" className="contact-link-icon" />
            </a>
            <a href="https://github.com/Yarden84" target="_blank" className="contact-link">
                <AiFillGithub size={iconSize} title="GitHub" className="contact-link-icon" />
            </a>
            <a 
                href="tel:71516386" 
                target="_blank" 
                className="contact-link"
                onMouseEnter={showDog}
                onMouseLeave={hideDog}
            >
                <AiFillPhone size={iconSize} title="Phone" className="contact-link-icon" />
            </a>
        </div>
    );
}

